import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import Vuelidate from 'vuelidate'
import VueConfigManager from 'vue-config-manager'
import Pace from 'pace'
import VueResource from 'vue-resource'
import VueCodeMirror from 'vue-codemirror'
import Autocomplete from 'v-autocomplete'

// Loaders
Pace.start()

// Configuration
Vue.use(VueConfigManager, {
  defaults: {
    endpoint: 'http://localhost:5102'
  },
  hosts: {
    'saumon-staging.userboat.com': {
      endpoint: 'https://saumon-staging.userboat.com'
    },
    'staging.userboat.com': {
      endpoint: 'https://staging.userboat.com'
    },
    'userboat.com': {
      endpoint: 'https://app.userboat.com'
    },
    'membres.saumonquebec.com': {
      endpoint: 'https://membres.saumonquebec.com'
    }
  }
})

// Router
Vue.use(Router)

// Vue resource
Vue.use(VueResource)

// Validation
Vue.use(Vuelidate)

// Codemirror
Vue.use(VueCodeMirror)

// Autocomplete
Vue.use(Autocomplete)

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes
})



// WEBPACK FOOTER //
// ./scripts/router/index.js